// extracted by mini-css-extract-plugin
module.exports = {"root":"_8c144b","particlesContainer":"_d0e851","particle":"_de4f86"};